import React, { memo } from 'react';
import { Map } from 'immutable';

import Popup from '../helpers/Popup';
import Button from '../helpers/Button';
import FormGroup from '../helpers/FormGroup';
import ErrorList from '../helpers/ErrorList';
import FormErrors from '../helpers/FormErrors';
import ActivityDropdown from '../helpers/ActivityDropdown';
import { InlineInput } from '../helpers/Input';

/**
 * Popup for push next actions.
 *
 * @param props {Object}.
 */
const PushNextActionPopupComponent = ({
  activities,
  errors,
  formData,
  formError,
  isSubmitting,
  onUpdate,
  onDateChange,
  onActivityChange,
  onClose,
}) => {
  const header = 'Push Next Actions';
  const footer = (
    <>
      <Button key="update" className="btn-primary" data-dismiss="modal" loading={isSubmitting} onClick={onUpdate}>
        Update
      </Button>
      <Button key="close" data-dismiss="modal" onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="pushNextActions">
      <div className="row">
        <FormGroup className="col-xs-6">
          <InlineInput
            label="Date"
            name="date"
            onChange={onDateChange}
            placeholder="date"
            type="date"
            value={formData.get('date')}
            autoFocus
            showLabel
          />
        </FormGroup>
        <FormGroup className="col-xs-6">
          <ActivityDropdown
            activities={activities}
            info={formData.get('activity', Map())}
            onChange={onActivityChange}
          />
        </FormGroup>
      </div>
      <FormErrors className="error text-danger" errors={formError} />
      {errors && <ErrorList className="text-danger" errors={errors} />}
      <p className="help-block">
        If no Activity is chosen, all existing Next Action Activities will be retained, and set to the chosen Date.
      </p>
    </Popup>
  );
};

export const PushNextActionPopup = memo(PushNextActionPopupComponent);
